import { render } from "./AlphaFucosidosisLeukocytes.vue?vue&type=template&id=32b8fc5f&scoped=true"
import script from "./AlphaFucosidosisLeukocytes.vue?vue&type=script&lang=js"
export * from "./AlphaFucosidosisLeukocytes.vue?vue&type=script&lang=js"

import "./AlphaFucosidosisLeukocytes.vue?vue&type=style&index=0&id=32b8fc5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b8fc5f"]])

export default __exports__